import { Downloader } from "./lib/Donwloader";


(async () => {
  const binaries = ['schema', 'query'];
  for (const prefix of binaries) {
    const binary = Downloader.get(prefix);
    console.log("Descargando:", binary.name);
    console.log("URL:", binary.url);
  }
  await Downloader.download();
})();
